import React from "react";

export const Footer = () => {
  return (
    <div className="text-center">
      <hr />
      <p className="fw-light mini lh-sm m-1">
        E-Office automation lorem ipsum dono imat | About E-Office | Manual |
        Report a problem
      </p>
      <p className="fw-lighter mini lh-sm ">
        Powered by lorem ipsum donor imat ven ips sukda mono
      </p>
    </div>
  );
};
